import React from "react";
import { connect } from "react-redux";
import { cloneDeep } from "lodash";

import FileUploader from "../../components/fileUploader/FileUploader";

import { addTemplate, getTemplatest } from "../../redux/templates/actions";
import * as authSelectors from "../../redux/auth/selectors";

class TemplateUploader extends React.Component {
  fileInputRef = React.createRef();

  prepareData = template => {
    if (template[0]) {
      template = template[0];
      const t = cloneDeep(template);
      t.text.opening = decodeURIComponent(atob(t.text.opening));
      t.text.closing = decodeURIComponent(atob(t.text.closing));
      return t;
    }

    return false;
  };

  addTemplate = async (...params) => {
    const { userId, addTemplate, getTemplatest } = this.props;
    await addTemplate(...params);

    getTemplatest(userId);
  };

  render() {
    const { userId } = this.props;
    return (
      <FileUploader
        fileInputRef={this.fileInputRef}
        userId={userId}
        onUploadFile={this.addTemplate}
        entity="template"
        prepareData={this.prepareData}
      />
    );
  }
}

export default connect(
  state => ({
    userId: authSelectors.getUserId(state)
  }),
  {
    addTemplate,
    getTemplatest
  }
)(TemplateUploader);
